import { ValidationError } from "sequelize"
import {
    CcRequirementReviewMethod,
    CcRequirementReviewMethodCreate,
    CcRequirementReviewMethodSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, validate, search,
} from "client/store/utils"
import { LangType, ReviewMethodsType } from "client/store"
import {
    CcRequirementReviewMethodList,
    CcRequirementReviewMethodFilters,
    CcRequirementReviewMethodValidation,
} from "./types"


export const GetDefaultReviewMethods = (
    methodList: CcRequirementReviewMethodList,
    methodIds: readonly number[],
) => {
    const defaultMethods: ReviewMethodsType = {}
    methodIds.forEach((methodId) => {
        const method = methodList[methodId]
        if (method.default) defaultMethods[method.id] = true
    })
    return defaultMethods
}

export const LoadCcRequirementReviewMethods = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementReviewMethod/accountId/${accountId}/projectId/${projectId}`)
    .then((methods: CcRequirementReviewMethod[]) => {
        const methodList: CcRequirementReviewMethodList = {}
        methods.forEach((method) => {
            methodList[method.id] = method
        })
        return methodList
    })
)

export const LoadCcRequirementReviewMethodById = (
    methodId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementReviewMethod/id/${methodId}/accountId/${accountId}/projectId/${projectId}`)
    .then((method: CcRequirementReviewMethod) => method)
)

export const SaveCcRequirementReviewMethod = (
    id: number,
    method: CcRequirementReviewMethodCreate,
    lang: LangType,
) => {
    const data: CcRequirementReviewMethodSave = {
        id,
        method,
    }
    return POST(
        "/ccRequirementReviewMethod/save",
        JSON.stringify(data),
    ).then((res) => {
        const newMethod = res as CcRequirementReviewMethod
        const error = res as ValidationError
        return {
            newMethodId: newMethod.id || null,
            validation: <CcRequirementReviewMethodValidation>validate(error, lang),
        }
    })
}

export const DeleteCcRequirementReviewMethod = (methodId: number) => (
    DELETE(`/ccRequirementReviewMethod/delete/${methodId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcRequirementReviewMethods = (
    accountId: number,
    projectId: number,
    defaultMethodsAssigned: boolean,
) => (
    GET(`/ccRequirementReviewMethod/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultMethodsAssigned}`)
    .then((success: boolean) => success)
)

export const SortCcRequirementReviewMethods = (
    methods: CcRequirementReviewMethod[],
    sortColumn: keyof CcRequirementReviewMethod,
    sortOrder: OrderType,
    filters: CcRequirementReviewMethodFilters,
) => {
    const methodsFiltered = methods.filter((method) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, method)
        return showRow
    })
    methodsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const methodIds: number[] = []
    methodsFiltered.forEach((group) => methodIds.push(group.id))

    return methodIds
}
